<div class="main-container-mid-side live-comp text sl-round round-5 card">
  <!--  class="asd" style="max-width: 100vw"-->
  <div>
    <story-slider [data]="this._DataHelper.liveSportsData" [filterItem]="_liveFilterItems" (clickedItem)="matchFilterBySport($event)"></story-slider>
  </div>
  <!-- <div class="live-standart-single-container text">
    <div class="live-standart-single-item" [ngClass]="{ active: standartSingleId == 1 }" (click)="StandartSingleChange(1)">
      {{ 'Standard' | translate }}
    </div>
    <div class="live-standart-single-item" [ngClass]="{ active: standartSingleId == 2 }" (click)="StandartSingleChange(2)">
      {{ 'Single' | translate }}
    </div>
  </div> -->
  <ng-container [ngSwitch]="this._DataHelper.liveMatchFilter">
    <div class="button-time-group">
      <button class="button" [ngClass]="{ active: this._DataHelper.liveMatchFilter === 'time' }" (click)="this.liveMatchFilterAction('time')">
        {{ 'live.filter.time' | translate }}
      </button>
      <button class="button" [ngClass]="{ active: this._DataHelper.liveMatchFilter === 'league' }" (click)="this.liveMatchFilterAction('league')">
        {{ 'live.filter.league' | translate }}
      </button>
    </div>
  </ng-container>

  <div class="live-bar-container-desktop">
    <div class="live-bar-left">
      <div class="live-page-icon-container">
        <ng-container
          *ngIf="
            this._DataHelper.selectedStoryItem?.imageUrl?.slice(0, -4).trim(' ') !== 'tennis' &&
              this._DataHelper.selectedStoryItem?.imageUrl?.slice(0, -4).trim(' ') !== 'icehockey' &&
              this._DataHelper.selectedStoryItem?.imageUrl?.slice(0, -4).trim(' ') !== 'basketball';
            else elseTemplate
          ">
          <image-loader-utils [url]="this._DataHelper.selectedStoryItem?.imageUrl?.slice(0, -4).trim(' ')" extraClasses="story-slider-icon live-page-icon"></image-loader-utils>
        </ng-container>
        <ng-template #elseTemplate>
          <image-loader-utils
            [url]="this._DataHelper.selectedStoryItem?.imageUrl?.slice(0, -4).trim(' ')"
            extraClasses="story-slider-icon live-page-icon"
            imageFormat="png"></image-loader-utils>
        </ng-template>
      </div>

      {{ this._DataHelper.liveHeaderTitle || this._DataHelper.selectedStoryItem?.sportName }} Live
    </div>
    <div class="live-bar-right">{{ this._DataHelper.comboSelectedOdd.OddNameLong | translate }}</div>
  </div>

  <div class="odd-header live-filter-container">
    <ng-container [ngSwitch]="this._DataHelper.liveMatchFilter">
      <div *ngSwitchCase="'time'" class="time-filter-container"></div>
      <div *ngSwitchCase="'league'" class="time-filter-container"></div>
    </ng-container>
    <div class="odd-combo-row">
      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(0)" class="combo-box">
        <select [(ngModel)]="combo1SelectedOdd" (change)="oddComboChange(combo1SelectedOdd, 0)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo1SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(1)" class="combo-box">
        <select [(ngModel)]="combo2SelectedOdd" (change)="oddComboChange(combo2SelectedOdd, 1)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo2SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(2)" class="combo-box">
        <select [(ngModel)]="combo3SelectedOdd" (change)="oddComboChange(combo3SelectedOdd, 2)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo3SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>

      <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(3)" class="combo-box">
        <select [(ngModel)]="combo4SelectedOdd" (change)="oddComboChange(combo4SelectedOdd, 3)">
          <option *ngFor="let odd of oddComboList" [ngValue]="odd">
            {{ odd.OddNameLong | translate }}
            <ng-container *ngIf="odd.OddNameLong2 !== ''">
              {{ odd.OddNameLong2 | translate }}
            </ng-container>
          </option>
        </select>
        <div class="odd-titles">
          <ng-container *ngFor="let item of combo4SelectedOdd.OddTitles">
            <span> {{ item }}</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="odd-header mobile odd-header-mobil-margin">
    <!-- <ng-container [ngSwitch]="this._DataHelper.liveMatchFilter">
      <div *ngSwitchCase="'time'" class="time-filter-container" (click)="this.liveMatchFilterAction('league')">
        <image-loader-utils url="time-switch" extraClasses="time-filter-icon"></image-loader-utils>
        <div class="time-filter-text">{{ 'live.filter.time' | translate }}</div>
      </div>
      <div *ngSwitchCase="'league'" class="time-filter-container" (click)="this.liveMatchFilterAction('time')">
        <image-loader-utils url="time-switch" extraClasses="time-filter-icon"></image-loader-utils>
        <div class="time-filter-text">{{ 'live.filter.league' | translate }}</div>
      </div>
    </ng-container> -->

    <div class="odd-box-row">
      <div class="odd-box" *ngFor="let odd of oddComboList" [ngClass]="{ active: combo1SelectedOdd.OddId == odd.OddId }" (click)="oddBoxClick(odd, 0)">
        {{ odd.OddName | translate }}
        <ng-container *ngIf="odd.OddNameLong2 !== ''">
          {{ odd.OddNameLong2 | translate }}
        </ng-container>
      </div>
    </div>
  </div>

  <livematch-component
    [oddLiveMarketingValue]="oddLiveMarketingp1001Value"
    [isInitialized]="this.isInitialized"
    [_selectedOdds]="this._selectedOdds"
    [liveDataLength]="this.__ResultLiveData ? this.__ResultLiveData.length : 0"
    [__ResultLiveData]="this.fullmatch"
    [isFavSection]="false"
    [sportSliderChanges]="liveFilterSelectedSportId"></livematch-component>
</div>
